export default function Card({ children, className = '' }) {
  return (
    <div className={`border border-border-dark rounded-large bg-white/[0.04] shadow-[0_12px_40px_rgba(0,0,0,0.35)] overflow-hidden ${className}`}>
      {children}
    </div>
  )
}

export function CardHeader({ children }) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-3 px-4 md:px-6 pt-4 md:pt-6 pb-3 md:pb-4">
      {children}
    </div>
  )
}

export function CardTitle({ children }) {
  return (
    <div className="font-mono text-xs tracking-wide uppercase text-muted-dark">
      {children}
    </div>
  )
}

export function CardBody({ children }) {
  return (
    <div className="px-4 md:px-6 pb-4 md:pb-6">
      {children}
    </div>
  )
}

